import { Avatar, colors, Divider, Drawer, Hidden, List, ListSubheader } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useOktaAuth } from '@okta/okta-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router';
import avatar from 'src/assets/images/technician.png';
import NavItem from 'src/components/NavItem';
import { getUser } from 'src/utils/Common';
import { isProduction } from 'src/utils/contants';
import { getMenu } from 'src/utils/storage/NavBarAdet';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  mobileDrawer: {
    width: 300,
  },
  desktopDrawer: {
    width: 300,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  navigation: {
    overflow: 'auto',
    padding: theme.spacing(0, 2, 2, 2),
    flexGrow: 1
  },
  profile: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  badge: {
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`
  },
  badgeDot: {
    height: 9,
    minWidth: 9
  },
  onlineBadge: {
    backgroundColor: colors.green[600]
  },
  awayBadge: {
    backgroundColor: colors.orange[600]
  },
  busyBadge: {
    backgroundColor: colors.red[600]
  },
  offlineBadge: {
    backgroundColor: colors.grey[300]
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  details: {
    marginLeft: theme.spacing(2)
  },
  moreButton: {
    marginLeft: 'auto',
    color: colors.blueGrey[200]
  }
}));

function renderNavItems({
  // eslint-disable-next-line react/prop-types
  items, subheader, key, ...rest
}, klima_teknisyeni) {
  return (
    <List key={key}>
      {subheader && <ListSubheader disableSticky>{subheader}</ListSubheader>}
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, ...rest }, klima_teknisyeni),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({
  acc, pathname, item, depth = 0
}, klima_teknisyeni) {
  if (klima_teknisyeni && item.klima_teknisyeni_gizle && item.klima_teknisyeni_gizle) {
    return acc;
  }
  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={item.href}
        label={item.label}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={item.href}
        label={item.label}
        title={item.title}
      />
    );
  }

  return acc;
}
let klima_teknisyeni = false;
function NavBar({
  open,
  onClose,
  className,
  ...rest
}) {
  const Menu = getMenu();
  const MenuCount = Menu.length;
  const { oktaAuth, authState } = useOktaAuth();
  const classes = useStyles();
  const location = useLocation();
  const [navConfig, setnavConfig] = React.useState([
    {
      subheader: 'İşlemler',
      items: Menu
    }
  ]
  );
  const SessionUser = getUser();




  const TechnicianImage = 'https://yetkiliservis.arcelik.com/SchedulingQuota/TechnicianImage/' + SessionUser.TechnicianId ? 0 : SessionUser.TechnicianId + '.png';

  useEffect(() => {
    if (open && onClose) {
      onClose();
    }
    setnavConfig([
      {
        subheader: 'İşlemler',
        items: Menu
      }
    ]);
    // eslint-disable-next-line
  }, [location.pathname, MenuCount, sessionStorage.getItem('MenuData'), localStorage.getItem('MenuData')]);


  const content = (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <nav className={classes.navigation}>
        {navConfig.map((list) => renderNavItems({
          items: list.items,
          subheader: list.subheader,
          pathname: location.pathname,
          key: list.subheader
        }, klima_teknisyeni))}
      </nav>
      <Divider className={classes.divider} />
    </div>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{
            paper: classes.mobileDrawer
          }}
          onClose={onClose}
          open={open}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{
            paper: classes.desktopDrawer
          }}
          open={open}
          onClose={onClose}
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

export default NavBar;
